import React from "react";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function SungChoi({...props}) {
    const { classes, className, style } = props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

  const data = useStaticQuery(
    graphql`
      query {
        image: file(relativePath: { eq: "sung-choi.jpg" }) {
          childImageSharp {
           gatsbyImageData(
             width: 200
             placeholder: BLURRED
             formats: [AUTO, WEBP, AVIF]
           )
          }
        }
      }
    `
  );

 const image = getImage(data.image)

    return (
      <GatsbyImage 
        image={image}
        alt="Portrait of Sung Choi"
        className={classNames(imageClasses, className)}
        style={style}/>
    )
}
